<template>
  <q-dialog
    v-model="dialog"
    persistent
    style="max-width: 600px"
    class="custom-font text-uppercase"
  >
    <q-card class="pragma-black text-white">
      <q-card-section class="q-pa-none">
        <q-toolbar class="bg-pragma text-white">
          <strong>
            <span>Detalle del ítem</span>
          </strong>
          <q-space></q-space>
          <q-btn
            flat
            icon="clear"
            @click="closeDialog()"
          ></q-btn>
        </q-toolbar>
      </q-card-section>
      <q-card-section>
        <div class="row q-gutter-y-sm">
          <div class="col-xs-6 q-pr-sm">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Cantidad
              </q-card-section>
              <q-card-section class="q-pa-xs">
                {{~~item.cantidad}}
              </q-card-section>
            </q-card>
          </div>
          <div class="col-xs-6">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Precio unitario
              </q-card-section>
              <q-card-section class="q-pa-xs">
                {{util.numberMoney(item.costo)}}
              </q-card-section>
            </q-card>
          </div>
          <div class="col-xs-12">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Unidad
              </q-card-section>
              <q-card-section class="q-pa-xs">
                {{item.unidad.descripcion}}
              </q-card-section>
            </q-card>
          </div>
          <div class="col-xs-12">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Tipo de compra
              </q-card-section>
              <q-card-section class="q-pa-xs">
                {{item.tipo_compra.descripcion}}
                <q-btn
                  round
                  icon="note"
                  class="bg-pragma"
                  v-if="(item.tipo_compra.id == 1 || item.tipo_compra.id == 7) && item.af"
                  @click="verActivoFijo(item.id)"
                ></q-btn>
              </q-card-section>
            </q-card>
          </div>
          <div class="col-xs-12">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Detalle
              </q-card-section>
              <q-card-section class="q-pa-xs text-uppercase">
                {{item.detalle}}
              </q-card-section>
            </q-card>
          </div>
          <!-- Caso de reposición y fondo rotativo  -->
          <div class="col-xs-12" v-if="props.modalidad_id == 3 || props.modalidad_id == 4">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Nro. Factura / Recibo
              </q-card-section>
              <q-card-section class="q-pa-xs">
                {{item.num_factura}}
              </q-card-section>
            </q-card>
          </div>
          <div class="col-xs-12" v-if="props.modalidad_id == 3 || props.modalidad_id == 4">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Fecha Factura / Recibo
              </q-card-section>
              <q-card-section class="q-pa-xs">
                {{vmoment(item.fecha_factura, 'YYYY-MM-DD').format('DD/MM/YYYY')}}
              </q-card-section>
            </q-card>
          </div>
          <div class="col-xs-12" v-if="props.modalidad_id == 3 || props.modalidad_id == 4">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Proyecto
              </q-card-section>
              <q-card-section class="q-pa-xs text-uppercase">
                {{item.proyecto}}
              </q-card-section>
            </q-card>
          </div>
          <div class="col-xs-12" v-if="props.modalidad_id == 3 || props.modalidad_id == 4">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Proveedor
              </q-card-section>
              <q-card-section class="q-pa-xs text-uppercase">
                {{item.proveedor}}
              </q-card-section>
            </q-card>
          </div>
          <div class="col-xs-12" v-if="props.modalidad_id == 3 || props.modalidad_id == 4">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Tipo
              </q-card-section>
              <q-card-section class="q-pa-xs">
                {{item.tipo}}
              </q-card-section>
            </q-card>
          </div>
          <!-- Fin del caso fondo rotativo y reposición -->
          <div class="col-xs-12">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Subtotal
              </q-card-section>
              <q-card-section class="q-pa-xs">
                {{util.numberMoney(item.subtotal)}}
              </q-card-section>
            </q-card>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import {inject, ref} from 'vue'
import moment from 'moment'
import util from '../../../plugins/util'
import env from '../../../../config/env'

export default {
  props: ['modalidad_id'],
  setup (props) {
    // Variables reactivas y no reactivas
    const bus = inject('bus')
    const vmoment = moment

    const dialog = ref(false)
    const item = ref({
      cantidad: null,
      unidad: {
        nombre: ''
      },
      tipo_compra: {
        descripcion: ''
      },
      detalle: null,
      precio_unitario: null,
      sub_total: 0,
    })

    // Métodos y funciones del componente
    const closeDialog = () => {
      item.value = {}
      dialog.value = false
    }

    const verActivoFijo = async (item_id) => {
      window.open(`${env.SERVER_URL}api/v1/solicitud-imprimir/formulario/af?id_item_rendido=${item_id}`)
    }


    // Creación del componente
    bus.on('openDialogDetalleItemSolicitud', (obj) => {
      item.value = obj
      dialog.value = true
    })

    bus.on('openDialogDetalleItemActivoFijo', (obj) => {
      item.value = obj
      item.value.af = true
      dialog.value = true
    })

    return {
      dialog,
      item,
      closeDialog,
      vmoment,
      props,
      util,
      verActivoFijo
    }
  }
}
</script>

<style>

</style>
